export default __webpack_public_path__ + "static/media/taxasTopbar.ee4f6afa.svg";